import templateUrl from './command-counsellor-add.html';
import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";

export const commandCounsellorAddComponent = {
  bindings: {
    details: "<",
    groupData: "<"
  },
  templateUrl,
  controller: class CommandCounsellorAddComponent {

    constructor($state, toastr, NewsCategoryService, CommandCounsellorsService, CommandCounsellorGroupsService) {
      "ngInject";
      this.$state = $state;
      this.toastr = toastr;
      this.NewsCategoryService = NewsCategoryService;
      this.CommandCounsellorsService = CommandCounsellorsService;
      this.CommandCounsellorGroupsService = CommandCounsellorGroupsService;
    }

    $onInit() {
      this.currentPage = 1;
      this.itemPerPage = 10;
      // console.log("addd", this.groupData.groupId)
      this.tmDetails = this.modifyCommandCounsellorsList(this.details);
      this.tmFormData = [];
      
    }

    getEligibleTransitionManagers() {
      return this.CommandCounsellorGroupsService.getEligibleTransitionManagers(123456).then((tm) => {
        // console.log('tmmmm',tm)
        //this.uCodesList = codes;
      })
    }

    modifyCommandCounsellorsList(tmList) {
      return {
        data: tmList.transitionManagers,
        feature: "Command Career Counselor Groups",
        config: {
          columnDefs: [
            {
              field: "name",
              enableSort: false,
              displayName: "TRANSITION MANAGER",
              className: "col-lg-4 col-md-4 col-sm-4 text-break",
            },
            {
              field: "unitIdentificationCode",
              enableSort: false,
              displayName: "UNIT IDENTIFICATION CODE",
              className: "col-lg-4 col-md-4 col-sm-4 text-break",
            },
            {
              field: "status",
              enableSort: true,
              displayName: "STATUS",
              rowClass: "text-capitalize",
              className: "col-lg-2 col-md-2 col-sm-2 text-break",
            },
            {
              type: "checkbox",
              field: "checkbox",
              enableSort: false,
            },
          ],
        },
      };
    }

    // onStatusChange(tmId, status) {
    //   if (tmId) {
    //     this.tmObj = {
    //       careerCounselorProfileId: tmId,
    //       status: status,
    //       groupId: this.groupData.groupId
    //     }
    //     this.isExist = this.tmFormData.includes(tmId);
    //     if (this.isExist) {
    //       this.details.tmDetailsForGroup.forEach((tmsId, ind) => {
    //         // console.log("tmsId",tmsId)
    //         if (tmsId === this.tmsId) {
    //           this.details.tmDetailsForGroup.splice(ind, 1);
    //           this.details.tmDetailsForGroup.push(tmObj)
    //         }
    //       });
    //     } else {
    //       this.tmFormData.push(tmId)
    //       this.details.tmDetailsForGroup.push(this.tmObj);
    //     }
    //   }

    // }
    tmValidation(){
      this.details.tmDetailsForGroup = [];
      this.details.tManagers = this.details.TransitionManagers;
      this.details.tManagers.filter((tmData) =>{ 
        if(tmData.status === true){
          this.tmObj = {
            careerCounselorProfileId: tmData.career_counselor_profile_id,
            status: tmData.status,
            groupId: this.groupData.groupId
          }
          this.details.tmDetailsForGroup.push(this.tmObj);
        }
      });

    }

    onSubmit() {
     this.tmValidation();
      // console.log(this.details)
      if (this.details.tmDetailsForGroup.length !== 0) {
        return this.CommandCounsellorGroupsService.addTMtoGroup(this.details).then((tm) => {
          this.toastr.success("Transistion Manager added to Group Successfully.");
          this.$state.go("commandCounsellorGroupsDetails", { group_id: this.groupData.groupId });
        }).catch((error) => {
            this.toastr.error(error.data.errors.message);
          });
      }else{
        if(this.details.tmDetailsForGroup.length === 0){
          this.toastr.error("Please Select Transistion Manager");
        }
      }
    }

    goBack() {
      this.$state.go("commandCounsellorGroupsDetails", { group_id: this.groupData.groupId });
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/components/command-counsellor-groups/command-counsellor-groups-details/command-counsellor-add/command-counsellor-add.component.js